<template>
  <div class="login-page">
    <div class="login-form-container">
      <div class="fiflbox-logo" />
      <el-form
        class="login-form"
        :model="form"
        :rules="formValidateRules"
        label-position="top"
        label-width="100px"
        @validate="handleValidateChange"
      >
        <el-form-item prop="new_password1">
          <el-input
            v-model="form.new_password1"
            type="password"
            placeholder="새 비밀번호"
            auto-complete="off"
            clearable
          />
        </el-form-item>
        <el-form-item prop="new_password2">
          <el-input
            v-model="form.new_password2"
            type="password"
            placeholder="새 비밀번호 확인"
            auto-complete="off"
            clearable
          />
        </el-form-item>
        <el-button
          class="default"
          :disabled="!isLoginActive"
          @click="handleClickLogin"
        >
          비밀번호 재설정
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { validatePassword } from "@/utils/form-validate-rules";
import { fiflboxApi } from '@/utils/api';

export default {
	name: "PasswordReset",
	data() {
		return {
			isLoginActive: false,
			form: {
				new_password1: "",
				new_password2: "",
				token: "",
				uid: "",
			},
			formValidateRules: {
				new_password1: [{ validator: validatePassword, trigger: "change" }],
				new_password2: [{ validator: validatePassword, trigger: "change" }],
			},
		};
	},
	async mounted() {
		let { token, uid } = this.$route.query;

		if (!token) {
			this.$alert("정상적인 접근이 아닙니다.", "비밀번호 재설정", {
				confirmButtonText: "확인",
				showClose: false,
				customClass: "fifl-message-box",
				confirmButtonClass: "gray",
			});

			return this.$router.push("/").catch(()=>{});
		}

		this.form.token = token;
		this.form.uid = uid;
	},
	methods: {
		handleValidateChange($event, isValidated) {
			this.isLoginActive = isValidated;
		},
		async handleClickLogin() {
			if (this.isLoginActive) {
				try {
          let { data } = await fiflboxApi.v2.postPasswordResetConfirm(this.form);

					await this.$alert(
						"비밀번호가 정상적으로 변경되었습니다.\n" +
							"다시 로그인해주시기 바랍니다",
						"비밀번호 재설정",
						{
							confirmButtonText: "확인",
							showClose: false,
							customClass: "fifl-message-box",
							confirmButtonClass: "gray",
						}
					);

					return this.$router.push("/").catch(()=>{});
				} catch (err) {
					this.$alert(
						"비밀번호 재설정을 실패하였습니다. 비밀번호 재설정 이메일을 다시 발급 받아주세요.",
						"비밀번호 재설정 오류",
						{
							confirmButtonText: "확인",
							showClose: false,
							customClass: "fifl-message-box",
							confirmButtonClass: "gray",
						}
					);
				}
			}
		},
	},
};
</script>

<style lang="scss">
.login-page {
	height: 100%;
}

.login-form-container {
	margin: 0 auto;
	box-sizing: border-box;
	padding-top: 15vh;
	width: 350px;

	.login-form {
		margin-top: 50px;
	}

	.login-other-links {
		margin-top: 20px;
		height: 33px;
		font-size: 15px;
		font-weight: normal;
		letter-spacing: -0.8px;
		text-align: center;
		color: #d3d3d3;

		a {
			line-height: 33px;
			display: inline-block;
			width: calc(50% - 10px);
			text-decoration: none;
			color: #7a7a7a;
			font-size: 13px;
			letter-spacing: -0.8px;

			&:hover {
				text-decoration: underline;
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.login-form-container {
		width: 100%;
		padding: 70px 40px;
		margin: 0;
		.login-form {
			margin-top: 70px;
		}
	}
}
</style>
